/**
 * generateEvidenceJson.ts - export JSON des preuves de TOUS les scans
 * (M365 + Azure) du client : résultats bruts + evidences, pour audit externe.
 */
import { saveAs } from 'file-saver';

export interface EvidenceJsonInput {
  orgName:    string;
  m365Scan?:  unknown;
  azureScan?: unknown;
}

export function downloadEvidenceJson(input: EvidenceJsonInput): void {
  const payload = {
    tool:        'NIS365 Auditor',
    generatedAt: new Date().toISOString(),
    organisation: input.orgName,
    scans: {
      m365:  input.m365Scan  ?? null,
      azure: input.azureScan ?? null,
    },
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const safe = (input.orgName || 'organisation').replace(/[^\w]+/g, '_');
  saveAs(blob, `NIS365_Preuves_${safe}_${new Date().toISOString().slice(0, 10)}.json`);
}
